const ExcelDownloadButtonBox = ({ title = "엑셀 다운로드", onClick }) => {
    return (
        <button type="button" className="btn btn-common download mr10" onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export default ExcelDownloadButtonBox;
